import React, { useState } from 'react';
import styles from './cityHomepage.module.scss';
import useTranslation from 'next-translate/useTranslation';
import cx from 'classnames';
import CouponList from '../couponList';
import FlyerList from '../flyerList';
import { Flyer } from '../../definitions/FlyerDefinitions';
import { Coupon } from '../../definitions/CouponDefinitions';

type sort = 'flyers' | 'coupons';

interface CityHomepageData {
  flyers: Flyer[];
  coupons: Coupon[];
}

interface CityHomepageProps {
  data: CityHomepageData;
  location: string;
}

export default function CityHomepage({ data, location }: CityHomepageProps): JSX.Element {
  const [sort, setSort] = useState<sort>('flyers');
  const { t } = useTranslation('application');

  function handleSort(sort: sort) {
    setSort(sort);
  }

  return (
    <>
      <div className={styles.buttonTabs}>
        <button onClick={() => handleSort('flyers')} className={cx(sort === 'flyers' && styles.underlined)}>
          {t('top_flyers')}
        </button>
        <button onClick={() => handleSort('coupons')} className={cx(sort === 'coupons' && styles.underlined)}>
          {t('top_coupons')}
        </button>
      </div>
      <section className="sections">
        {sort === 'flyers' && (
          <FlyerList flyers={data.flyers.slice(0, 20)} location={location} category={'All Flyers'} />
        )}
        {sort === 'coupons' && (
          <CouponList
            coupons={data.coupons.slice(0, 20)}
            category={'All Deals'}
            shallowRouting={false}
            location={location}
          />
        )}
      </section>
    </>
  );
}
